import {
  ACCESS_TOKEN_NAME,
  JSON_CONTENT_TYPE,
} from '../../_constant/constants';
import { AccountantDeleteDto } from '../../_dto/_accountant/AccountantDeleteDto';
import { IApiParams } from '../../_interface/IApiParams';
import { getApi } from '../getApi';

export const apiDeleteAccountant = async (dto: AccountantDeleteDto) => {
  const params: IApiParams = {
    url: '/accountant/delete.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'DELETE', dto);
};
